import { memo } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { DROP_DESCRIPTION_MARKDOWN_COMPONENTS } from 'root/src/client/v2/_pages/drop/redesign/dropDescriptionMarkdown';
// The Drop Details card now lives in the hero (see DropDetailsCard / RedesignDropPage), so the
// Overview section is just the full-width description + genres below the fold. The description
// (gameDescriptionBody) is markdown, rendered the same way the legacy drop page does (react-markdown
// + remark-gfm), themed for the redesign via DROP_DESCRIPTION_MARKDOWN_COMPONENTS.
export const DropOverviewSection = memo(({ drop }) => {
    var _a;
    return (<section id="overview" className="scroll-mt-40 px-4 py-12 sm:px-6 lg:px-8">
		<div className="mx-auto max-w-7xl">
			<h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl">Overview</h2>
			{drop.gameDescriptionBody && (<div className="mt-4 max-w-3xl">
					<Markdown remarkPlugins={[remarkGfm]} components={DROP_DESCRIPTION_MARKDOWN_COMPONENTS}>
						{drop.gameDescriptionBody}
					</Markdown>
				</div>)}
			{((_a = drop.genres) === null || _a === void 0 ? void 0 : _a.length) > 0 && (<div className="mt-5 flex flex-wrap gap-2">
					{drop.genres.map(genre => (<span key={genre} className="rounded-full border border-solid border-white/[0.06] bg-white/[0.03] px-3 py-1 text-xs text-muted-foreground">{genre}</span>))}
				</div>)}
		</div>
	</section>);
});
